/** Paint floor matches Land Records tiles (z12–16). Zoom never flips the toggle. */
export const PARCEL_PAINT_MIN_ZOOM = 12;

export function shouldPaintParcels({ enabled, zoom, minZoom = PARCEL_PAINT_MIN_ZOOM }) {
  return Boolean(enabled) && Number(zoom) >= Number(minZoom);
}
